import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Location } from "react-router-dom";

interface IInitialState {
  navigateToAfterLogin: null | Location;
  navigateTo: null | Location;
  isCookiesModalVisible: boolean;
}

const initialState: IInitialState = {
  navigateToAfterLogin: null,
  navigateTo: null,
  isCookiesModalVisible: false,
};

const bootstrapReducer = createSlice({
  name: "[Bootstrap]",
  initialState,
  reducers: {
    setNavigateToAfterLogin: (state, action: PayloadAction<Location | null>) => ({
      ...state,
      navigateToAfterLogin: action.payload,
    }),

    setNavigateTo: (state, action: PayloadAction<Location | null>) => ({
      ...state,
      navigateTo: action.payload,
    }),

    setIsCookiesModalVisible: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isCookiesModalVisible: action.payload,
    }),
  },
});

export const {
  setNavigateToAfterLogin,
  setNavigateTo,
  setIsCookiesModalVisible,
} = bootstrapReducer.actions;

export default bootstrapReducer.reducer;
